import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { trackEvent, EVENTS } from "@/utils/track";

export default function ValueProposition() {
  return (
    <section className="bg-navy py-24 lg:py-32">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8">
        <h2
          data-testid="value-title"
          className="font-heading text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-[2.6rem] lg:leading-[1.15]"
        >
          No vendemos recordatorios.{" "}
          <span className="text-[#9FB8D8]">Recuperamos capacidad productiva.</span>
        </h2>
        <p className="mx-auto mt-6 max-w-3xl text-base leading-relaxed text-[#C3D2E6] sm:text-lg">
          Una clínica dental no pierde únicamente una cita cuando un paciente no aparece.
          Pierde una hora de equipo, una oportunidad de tratamiento y una parte de su
          capacidad mensual. DentalAi actúa antes, durante y después de cada
          confirmación para reducir el riesgo y llenar los huecos disponibles.
        </p>
        <p
          data-testid="value-highlight"
          className="mx-auto mt-8 max-w-3xl rounded-xl border border-white/15 bg-white/[0.06] p-6 font-heading text-lg font-semibold leading-relaxed text-white sm:text-xl"
        >
          “Recuperamos horas de sillón que hoy se pierden sin cobrar, llenando
          automáticamente las cancelaciones antes de que se conviertan en costes
          hundidos.”
        </p>
        <Button
          asChild
          data-testid="value-cta-button"
          size="lg"
          className="mt-10 whitespace-normal rounded-lg bg-white px-8 py-6 text-base font-semibold text-navy shadow-lg transition-all duration-200 hover:bg-platinum"
          onClick={() => trackEvent(EVENTS.CTA_PRINCIPAL, { ubicacion: "propuesta_valor" })}
        >
          <a href="#calculadora">
            Calcula tu oportunidad de recuperación
            <ArrowRight className="ml-2 h-4 w-4" />
          </a>
        </Button>
      </div>
    </section>
  );
}
